export default "__VITE_ASSET__DmG5c2dL__"